import { requestV2Internal, requestV2 } from './request'
import { SEOData } from './seo.service'

interface SolutionListReqData {
  region: string
  typeDocId: string
  offset?: number
  limit?: number
}
interface SolutionInfoReqData {
  region: string
  docId: string
}

export type SolutionListData = {
  count: number
  topBanner: {
    mediaUrl: string
    mediaUrlH5: string
    jumpUrl: string
    title: string
    desc: string
    fontColor: string
    needAuto: boolean
  }
  item: Array<{
    docId: string
    title: string
    mediaUrl: string
    mediaH5Url: string
    jumpUrl: string
    content: string
  }>
  tabTitle: string
  seoData?: SEOData | null
}

export type TSecondSolutionItem = {
  title: string
  // 案例
  customerCaseTitle: string
  customerCaseItems: Array<{
    docId: string
    country: string
    industryName: string
    title: string
    tabTitle: string
    desc: string
    mediaUrls: string[]
    productName: Array<string>
  }>
  sceneItems: Array<{
    title: string
    topTitle: string
    topContent: string
    bottomTitle: string
    bottomContent: string
    mediaUrl: Array<{
      mediaUrl: string
      title: string
      fontColor: string
    }>
    productTitle: string
    products: Array<{
      title: string
      content: string
      mediaUrl: string
      jumpUrl: string
      moreTitle: string
    }>
  }>
}
export type SolutionDetailsData = {
  title: string
  tabTitle: string

  topBanner: Array<{
    mediaUrl: string
    mediaUrlH5: string
    jumpUrl: string
    title: string
    desc: string
    fontColor: string
    needAuto: boolean
  }>

  // 机器人如何赋能
  middleTitle: string
  middleSmallTitle: string
  middleBottomDesc: string
  middleItems: Array<{
    mediaUrl: string
    title: string
    desc: string
  }>

  // 全环节覆盖
  middleBanner: {
    title: string
    smallTitle: string
    desc: string
    mediaUrl: string
    mediaUrlH5: string
    jumpUrl: string
    fontColor: string
    needAuto: boolean
  }

  secondSolutionModule: {
    smallTitle: string
    secondSolutionItem: Array<TSecondSolutionItem>
  }

  // 下载 案列pdf
  downloadTitle: string
  downloadSmallTitle: string
  downloadItems: Array<{
    title: string
    desc: string
    mediaUrl: string
    downloadUrl: string
    downloadMoreTitle: string
    downloadUrlTitle: string
  }>

  // 其他行业
  otherSolutionTitle: string
  otherSolutionSmallTitle: string
  otherSolutionMoreTitle: string
  otherSolutionItems: Array<{
    docId: string
    mediaUrl: string
    title: string
    content: string
    jumpUrl: string
  }>
  seoData?: SEOData | null
}

// 客户案例列表
export async function getSolutions(data?: SolutionListReqData): Promise<SolutionListData> {
  const res = await requestV2Internal('/solution/list', { ...data })
  return res
}

// 客户案例详情
export async function getSolutionDetails(data?: SolutionInfoReqData): Promise<SolutionDetailsData> {
  const res = await requestV2('/solution/info', { ...data })
  return res
}

// 客户案例详情
export async function getSolutionDetailsInternal(data?: SolutionInfoReqData): Promise<SolutionDetailsData> {
  const res = await requestV2Internal('/solution/info', { ...data })
  return res
}
